import { Controller } from "@hotwired/stimulus";

// Reports a GA4 event the first time the element is meaningfully visible:
// at least 30% of it, or enough of it to fill half the viewport — tall
// elements (the stacked mobile pricing cards) can never reach a 30% ratio
// on small screens.
//
// When the impression happens before the visitor answers the consent banner,
// gtag does not exist yet; the event then waits for fiolo:analytics-ready
// (dispatched by the consent controller) instead of being dropped.
export default class extends Controller {
  static values = {
    event: String,
    location: String,
  };

  connect() {
    // Turbo renders cached previews before the final response; reporting on
    // both would double-count one navigation.
    if (document.documentElement.hasAttribute("data-turbo-preview")) {
      return;
    }

    this.reportOnce = () => this.report();
    this.observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => this.visibleEnough(entry))) {
        return;
      }

      this.observer.disconnect();
      if (typeof window.gtag === "function") {
        this.report();
      } else {
        window.addEventListener("fiolo:analytics-ready", this.reportOnce, { once: true });
      }
    }, { threshold: [0, 0.05, 0.1, 0.15, 0.2, 0.25, 0.3] });
    this.observer.observe(this.element);
  }

  disconnect() {
    this.observer?.disconnect();
    window.removeEventListener("fiolo:analytics-ready", this.reportOnce);
  }

  visibleEnough(entry) {
    if (!entry.isIntersecting) {
      return false;
    }

    return entry.intersectionRatio >= 0.3 ||
      (entry.rootBounds !== null && entry.intersectionRect.height >= entry.rootBounds.height / 2);
  }

  report() {
    window.gtag("event", this.eventValue, { location: this.locationValue });
  }
}
